export const walletListenerRecipe = (invalidateCache: () => void) => {
  return (event: MessageEvent) => {
    if (!event.data) return;
    invalidateCache();
  };
};
